<template>
  <article>
    <div class="content pd-font">
      <div>
        <div class="has-text-centered" v-if="hasSlotData">
          <div class="image is-inline-block profile-image">
            <slot name="image" />
          </div>
        </div>
        <div>
          <p class="pd-font">
            <span class="is-5 title">{{ data.name }}</span
            ><a :href="data.linkedin" target="_blank" v-if="data.linkedin">
              <i class="fab fa-linkedin icon"></i
            ></a>
            <span v-else />
            <br />
            <small
              ><span
                v-html="data.role"
                class="uppercase spacing subtitle is-6"
              ></span>
            </small>
            <br />
            <small
              ><a :href="`mailto:${data.mail}`">{{ data.mail }}</a></small
            >
          </p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "Profile",
  props: {
    data: Object,
  },
  methods: {},
  computed: {
    hasSlotData() {
      return this.$slots["image"];
    },
  },
};
</script>

<style lang="css" scoped>
.profile-image {
  max-width: 10rem;
}
.icon {
  padding-left: 0.5em;
}
</style>
